import { render, staticRenderFns } from "./best_dta.vue?vue&type=template&id=71806f56&"
import script from "./best_dta.vue?vue&type=script&lang=js&"
export * from "./best_dta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports